import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";

const SkeletonTourSearchPanelComponent: FC = () => {
  return (
    <div className="flex flex-col gap-4 rounded-2xl bg-white p-4 shadow-search-mobile md:p-6 md:shadow-search">
      <Skeleton className="h-16 w-full" />
      <div className="flex w-full flex-col gap-4 md:flex-row">
        <Skeleton className="h-[66px] w-full" />
        <Skeleton className="h-[66px] w-full md:w-[178.67px] xl:h-16" />
        <Skeleton className="h-12 w-full md:hidden" />
      </div>
    </div>
  );
};

export default SkeletonTourSearchPanelComponent;
